export default __webpack_public_path__ + "static/media/content.c65ef8c1.png";